/* tslint:disable */
/* eslint-disable */
/**
 * Stacks Blockchain API
 * Welcome to the API reference overview for the [Stacks Blockchain API](https://docs.hiro.so/stacks-blockchain-api).  [Download Postman collection](https://hirosystems.github.io/stacks-blockchain-api/collection.json) 
 *
 * The version of the OpenAPI document: STACKS_API_VERSION
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A burn block
 * @export
 * @interface BurnBlock
 */
export interface BurnBlock {
    /**
     * Unix timestamp (in seconds) indicating when this block was mined.
     * @type {number}
     * @memberof BurnBlock
     */
    burn_block_time: number;
    /**
     * An ISO 8601 (YYYY-MM-DDTHH:mm:ss.sssZ) indicating when this block was mined.
     * @type {string}
     * @memberof BurnBlock
     */
    burn_block_time_iso: string;
    /**
     * Hash of the anchor chain block
     * @type {string}
     * @memberof BurnBlock
     */
    burn_block_hash: string;
    /**
     * Height of the anchor chain block
     * @type {number}
     * @memberof BurnBlock
     */
    burn_block_height: number;
    /**
     * Hashes of the Stacks blocks included in the burn block
     * @type {Array<string>}
     * @memberof BurnBlock
     */
    stacks_blocks: Array<string>;
    /**
     * Average time between blocks in seconds. Returns 0 if there is only one block in the burn block.
     * @type {number}
     * @memberof BurnBlock
     */
    avg_block_time: number;
    /**
     * Total number of transactions in the Stacks blocks associated with this burn block
     * @type {number}
     * @memberof BurnBlock
     */
    total_tx_count: number;
}

export function BurnBlockFromJSON(json: any): BurnBlock {
    return BurnBlockFromJSONTyped(json, false);
}

export function BurnBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): BurnBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'burn_block_time': json['burn_block_time'],
        'burn_block_time_iso': json['burn_block_time_iso'],
        'burn_block_hash': json['burn_block_hash'],
        'burn_block_height': json['burn_block_height'],
        'stacks_blocks': json['stacks_blocks'],
        'avg_block_time': json['avg_block_time'],
        'total_tx_count': json['total_tx_count'],
    };
}

export function BurnBlockToJSON(value?: BurnBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'burn_block_time': value.burn_block_time,
        'burn_block_time_iso': value.burn_block_time_iso,
        'burn_block_hash': value.burn_block_hash,
        'burn_block_height': value.burn_block_height,
        'stacks_blocks': value.stacks_blocks,
        'avg_block_time': value.avg_block_time,
        'total_tx_count': value.total_tx_count,
    };
}

